import React from 'react';
import { Card } from "@/components/ui/card";
import { Settings, Brain, Video } from 'lucide-react';
import { cn } from '@/lib/utils';

const ThreePillars: React.FC = () => {
  const pillars = [
    {
      id: "automation",
      icon: <Settings className="h-6 w-6 text-white group-hover:text-blue-300 transition-all duration-300" />,
      title: "Business Automation Systems",
      description: "Custom dashboards that automate your marketing, sales, and operations. Manage everything from one intelligent command center.",
      gradient: "bg-gradient-to-br from-blue-600 to-indigo-800",
    },
    {
      id: "persona-ai",
      icon: <Brain className="h-6 w-6 text-white group-hover:text-purple-300 transition-all duration-300" />,
      title: "PersonaAI - Behavioral Intelligence",
      description: "AI that understands customer psychology and predicts behavior. Market research, customer insights, and decision modeling.",
      gradient: "bg-gradient-to-br from-purple-600 to-indigo-800",
    },
    {
      id: "charx",
      icon: <Video className="h-6 w-6 text-white group-hover:text-teal-300 transition-all duration-300" />,
      title: "CharX + Creative AI",
      description: "AI-generated avatars, videos, and visual content. Automated creative production for marketing and training.",
      gradient: "bg-gradient-to-br from-teal-600 to-blue-800",
    }
  ];

  return (
    <section className="py-20 px-6 md:px-10">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Three Ways We Transform Your Business
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, index) => (
            <Card 
              key={pillar.id}
              className={cn(
                "p-8 rounded-xl text-white shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 overflow-hidden relative h-full group cursor-pointer",
                pillar.gradient
              )}
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <div className="absolute top-0 right-0 w-32 h-32 -mt-8 -mr-8 rounded-full bg-white/10 blur-2xl"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 -mb-6 -ml-6 rounded-full bg-white/5 blur-xl"></div>
              
              <div className="relative z-10 flex flex-col items-center text-center h-full">
                <div className="mb-5 p-3 rounded-full bg-white/10 inline-flex items-center justify-center w-12 h-12">
                  {pillar.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white transition-all duration-300 group-hover:translate-y-1">
                  {pillar.title}
                </h3>
                <p className="text-white/80 text-base mb-6 transition-all duration-300 group-hover:text-white">
                  {pillar.description}
                </p>
                <div className="text-white/90 text-sm font-medium group-hover:translate-y-1 transition-all duration-300 flex items-center mt-auto">
                  Learn More <span className="ml-1 transform group-hover:translate-x-1 transition-transform duration-300">→</span>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThreePillars;